import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import footerImg from '../../../../assest/img/logo-gojapan.png';
import { useTranslation } from 'react-i18next';
Footer.propTypes = {};

const preventDefault = (event) => event.preventDefault();

const socialStyle = {
    border: '1px solid #6d6d6d',
    color: '#6d6d6d',
    borderRadius: '5px',
    padding: '5px',
    fontSize: '0.75rem',
    '@media screen and (min-width: 600px)': {
        fontSize: '1.5rem',
    },
};
function Footer(props) {
    const { t, i18n } = useTranslation();
    const [fbUrl, setFBUrl] = useState();
    const fbUrls = {
        default: 'https://www.facebook.com/gojapan.creditcard',
        ph: 'https://www.facebook.com/gojapan.creditcard.ph',
        vi: 'https://www.facebook.com/gojapan.thetindung/',
    };

    useEffect(() => {
        let fbUrl = '';
        switch (i18n.language) {
            case 'fil': {
                fbUrl = fbUrls.ph;
                break;
            }
            case 'km': {
                fbUrl = fbUrls.default;
                break;
            }
            case 'zh': {
                fbUrl = fbUrls.default;
                break;
            }
            case 'id': {
                fbUrl = fbUrls.default;
                break;
            }
            case 'pt': {
                fbUrl = fbUrls.default;
                break;
            }
            case 'en': {
                fbUrl = fbUrls.default;
                break;
            }
            default:
                fbUrl = fbUrls.vi;
        }
        setFBUrl(fbUrl);
    }, [i18n.language]);

    return (
        <Box
            component={'section'}
            sx={{ background: '#f0f4fd', paddingTop: '60px' }}
        >
            <Container maxWidth="xl">
                <Box
                    component={'img'}
                    src={footerImg}
                    sx={{ paddingBottom: '10px' }}
                ></Box>
                <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={6} sm={9}>
                        <Box>
                            {/* <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <LocationOnIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                {t('head4_location')}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <PhoneInTalkIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                03-6907-1353
                            </Typography> */}
                            <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <FacebookOutlinedIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                <Link
                                    target="_blank"
                                    rel="noopener"
                                    href={fbUrl}
                                    underline="hover"
                                    sx={{
                                        color: '#000000',
                                    }}
                                >
                                    {fbUrl}
                                </Link>
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <EmailIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                {t('head4_email')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <Box>
                            <Typography
                                variant="h3"
                                sx={{ fontSize: '16px', paddingBottom: '10px' }}
                            >
                                {t('contact_value1')}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <PhoneInTalkIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                03-5996-1111
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ fontSize: '14px', paddingBottom: '5px' }}
                            >
                                <PhoneInTalkIcon
                                    sx={{
                                        fontSize: '16px',
                                        // color: '#ff008c',
                                        marginRight: '5px',
                                        verticalAlign: 'text-bottom',
                                    }}
                                />
                                0570-064-133
                            </Typography>
                            <ul>
                                <li>{t('contact_value2')}</li>
                                <li>{t('contact_value3')}</li>
                            </ul>
                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" sx={{ paddingY: 4 }}>
                    Copyright © 2022 gojapanmobile. All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
}

export default Footer;
